import React from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../context/DataContext';
import './Hotels.css';
import thailandImg from '../assets/images/places/895.jpg';
import vietnamImg from '../assets/images/places/vacation-stone-vietnam-fresh-green-china.jpg';

export function Places() {
  const { data } = useData();
  const [active, setActive] = React.useState('All');
  const cats = ['All','Heritage','Beach','Temple','Nature','Wildlife'];
  const filtered = active === 'All' ? data.places : data.places.filter(p => p.category === active);
  return (
    <div>
      <div className="page-hero">
        <div className="page-hero-content">
          <p className="section-eyebrow">✦ Destinations</p>
          <h1 className="playfair">Top Attractions in Sri Lanka</h1>
          <p>Beautiful Beaches · Cultural Heritage · Wildlife Safaris · Scenic Highlands</p>
        </div>
      </div>
      <section className="section" style={{background:'var(--ivory)'}}>
        <div className="filter-row">
          {cats.map(c => (
            <button key={c} className={`filter-btn ${active===c?'filter-btn--active':''}`} onClick={()=>setActive(c)}>{c}</button>
          ))}
        </div>
        <div className="img-card-grid">
          {filtered.map(place => (
            <div key={place.id} className="img-card">
              <div className="img-card__img-wrap">
                <img src={place.image} alt={place.name} className="img-card__img" loading="lazy" />
                <span className="badge badge-gold img-card__badge">{place.badge}</span>
                <div className="img-card__rating">★ {place.rating}</div>
              </div>
              <div className="img-card__body">
                <span className="badge badge-sand" style={{marginBottom:10,display:'inline-block'}}>{place.category}</span>
                <h3 className="playfair img-card__name">{place.name}</h3>
                <p className="img-card__desc">{place.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export function Hotels() {
  return (
    <div>
      <div className="page-hero">
        <div className="page-hero-content">
          <p className="section-eyebrow">✦ Accommodation</p>
          <h1 className="playfair">Handpicked Hotels & Resorts</h1>
          <p>From Comfortable Stays to Luxurious Escapes – Choose the Hotel That Matches Your Journey.</p>
        </div>
      </div>

      {/* ── INTRO ── */}
      <section className="section" style={{background:'#fff'}}>
        <div className="hotels-intro-wrap">
          <div className="hotels-intro-text">
            <p className="section-eyebrow">✦ Our Hotel Selection</p>
            <h2 className="section-title playfair">A Stay for Every Traveller</h2>
            <p style={{color:'var(--muted)',lineHeight:1.8,fontSize:'0.97rem'}}>
              At <strong>Mishti Holidays</strong>, we believe every traveler deserves a stay
              that matches their comfort, style, and budget. That's why we offer a carefully
              selected range of <strong>3-Star, 4-Star, and 5-Star hotels</strong> across our
              destinations, ensuring a relaxing and memorable experience throughout your journey.
            </p>
          </div>

          {/* ── STAR CATEGORIES ── */}
          <div className="hotel-stars-grid">

            <div className="hotel-star-card hotel-star-card--3">
              <div className="hotel-star-card__stars">⭐⭐⭐</div>
              <div className="hotel-star-card__label">3-Star Hotels</div>
              <h3 className="playfair hotel-star-card__title">Comfort & Value</h3>
              <p className="hotel-star-card__desc">
                Comfortable, clean, and budget-friendly accommodations with essential
                modern amenities — perfect for travelers seeking quality stays at an
                affordable price.
              </p>
              <ul className="hotel-star-card__features">
                <li>Clean & comfortable rooms</li>
                <li>Essential modern amenities</li>
                <li>Budget-friendly pricing</li>
                <li>Great locations</li>
              </ul>
              <Link to="/contact" className="hotel-star-card__btn">Enquire Now →</Link>
            </div>

            <div className="hotel-star-card hotel-star-card--4">
              <div className="hotel-star-card__badge">Most Popular</div>
              <div className="hotel-star-card__stars">⭐⭐⭐⭐</div>
              <div className="hotel-star-card__label">4-Star Hotels</div>
              <h3 className="playfair hotel-star-card__title">Style & Comfort</h3>
              <p className="hotel-star-card__desc">
                Enjoy enhanced comfort with stylish interiors, spacious rooms, excellent
                dining options, and premium facilities for a more refined travel experience.
              </p>
              <ul className="hotel-star-card__features">
                <li>Stylish interiors & spacious rooms</li>
                <li>Excellent dining options</li>
                <li>Premium facilities & services</li>
                <li>Swimming pool & gym</li>
              </ul>
              <Link to="/contact" className="hotel-star-card__btn">Enquire Now →</Link>
            </div>

            <div className="hotel-star-card hotel-star-card--5">
              <div className="hotel-star-card__stars">⭐⭐⭐⭐⭐</div>
              <div className="hotel-star-card__label">5-Star Hotels</div>
              <h3 className="playfair hotel-star-card__title">Pure Luxury</h3>
              <p className="hotel-star-card__desc">
                Experience luxury at its finest with world-class hospitality, elegant
                accommodations, gourmet dining, spa facilities, breathtaking locations,
                and exceptional personalized service.
              </p>
              <ul className="hotel-star-card__features">
                <li>World-class hospitality</li>
                <li>Gourmet dining & spa</li>
                <li>Breathtaking locations</li>
                <li>Personalized butler service</li>
              </ul>
              <Link to="/contact" className="hotel-star-card__btn">Enquire Now →</Link>
            </div>

          </div>

          {/* ── FOR WHOM ── */}
          <div className="hotels-for-whom">
            <p className="section-eyebrow" style={{textAlign:'center'}}>✦ Perfect For</p>
            <h2 className="section-title playfair" style={{textAlign:'center'}}>Whatever Your Journey</h2>
            <div className="hotels-for-grid">
              {[
                ['💑','Honeymoon Couples','Romantic luxury stays with private settings and scenic views.'],
                ['👨‍👩‍👧‍👦','Family Vacations','Spacious family rooms with kid-friendly facilities.'],
                ['👥','Group Tours','Block bookings with group rates and dedicated services.'],
                ['💼','Corporate Trips','Business-ready hotels with conference and meeting facilities.'],
                ['🎉','Luxury Escapes','Five-star resorts with world-class amenities and experiences.'],
                ['🎒','Budget Travel','Clean, comfortable 3-star stays that don\'t break the bank.'],
              ].map(([icon, title, desc]) => (
                <div key={title} className="hotels-for-card">
                  <span>{icon}</span>
                  <h4 className="playfair">{title}</h4>
                  <p>{desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* ── PROMISE ── */}
          <div className="hotels-promise">
            <div className="hotels-promise__icon">🏨</div>
            <h3 className="playfair">Our Promise to You</h3>
            <p>
              Whether you're planning a family vacation, honeymoon, group tour, corporate
              trip, or a luxury escape — <strong>Mishti Holidays</strong> helps you choose
              the perfect hotel to suit your travel preferences.
            </p>
            <p style={{marginTop:12}}>
              <strong>Your comfort is our priority, and your satisfaction is our promise.</strong>
            </p>
            <div style={{marginTop:28,display:'flex',gap:14,justifyContent:'center',flexWrap:'wrap'}}>
              <Link to="/contact" className="btn-primary">Book Your Hotel →</Link>
              <a href="tel:9740749793" className="btn-secondary">📞 Call Us</a>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export function Food() {
  const { data } = useData();
  return (
    <div>
      <div className="page-hero">
        <div className="page-hero-content">
          <p className="section-eyebrow">✦ Cuisine</p>
          <h1 className="playfair">A Feast of Sri Lankan Flavours</h1>
          <p>Shopping & Cuisine — explore the vibrant food culture of the Pearl of the Indian Ocean.</p>
        </div>
      </div>
      <section className="section" style={{background:'var(--sand)'}}>
        <div className="img-card-grid">
          {data.foods.map(f => (
            <div key={f.id} className="img-card">
              <div className="img-card__img-wrap" style={{height:200}}>
                <img src={f.image} alt={f.name} className="img-card__img" loading="lazy" />
              </div>
              <div className="img-card__body">
                <h3 className="playfair img-card__name">{f.name}</h3>
                <p className="img-card__desc">{f.desc}</p>
                <div className="spice-row">
                  <span>Spice</span>
                  <div className="spice-bar-f">{[1,2,3,4,5].map(i=><span key={i} className={`sd ${i<=f.spice?'sd--on':''}`}/>)}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export function Vehicles() {
  const { data } = useData();
  return (
    <div>
      <div className="page-hero">
        <div className="page-hero-content">
          <p className="section-eyebrow">✦ Transport</p>
          <h1 className="playfair">Comfortable Transport Facilities</h1>
          <p>Choose from budget sedans to luxury SUVs — all with professional English-speaking drivers.</p>
        </div>
      </div>
      <section className="section" style={{background:'var(--ivory)'}}>
        <div className="img-card-grid">
          {data.vehicles.map(v => (
            <div key={v.id} className="img-card">
              <div className="img-card__img-wrap" style={{height:200}}>
                <img src={v.image} alt={v.name} className="img-card__img" loading="lazy" />
                <span className={`badge ${v.badge==='Popular'?'badge-gold':'badge-blue'} img-card__badge`}>{v.badge}</span>
              </div>
              <div className="img-card__body">
                <h3 className="playfair img-card__name">{v.name}</h3>
                <p className="img-card__location">👥 {v.cap}</p>
                <div className="img-card__tags">
                  {(Array.isArray(v.features)?v.features:(v.features||'').split(',').map(s=>s.trim())).filter(Boolean).map((f,i)=>(
                    <span key={i} className="tag">{f}</span>
                  ))}
                </div>
                <div className="img-card__footer">
                  <Link to="/contact" className="btn-primary" style={{width:'100%',justifyContent:'center',fontSize:'0.85rem'}}>Enquire →</Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export function Packages() {
  const { data } = useData();
  return (
    <div>
      <div className="page-hero">
        <div className="page-hero-content">
          <p className="section-eyebrow">✦ Holiday Packages</p>
          <h1 className="playfair">Tailor Made Holiday Packages</h1>
          <p>Honeymoon · Family · Corporate · Custom — we craft every trip with personal care.</p>
        </div>
      </div>
      <section className="section" style={{background:'var(--ivory)'}}>
        <div className="pkg-full-grid">
          {data.packages.map(pkg => (
            <div key={pkg.id} className="pkg-full-card">
              <div className="pkg-full-card__img-wrap">
                <img src={pkg.image} alt={pkg.name} className="pkg-full-card__img" loading="lazy" />
                <div className="pkg-full-card__img-overlay" />
                {pkg.tag && <span className="pkg-full-card__tag">{pkg.tag}</span>}
                <div className="pkg-full-card__days-badge">{pkg.days} Days</div>
              </div>
              <div className="pkg-full-card__body">
                <span className="pkg-full-card__type">{pkg.type}</span>
                <h3 className="playfair pkg-full-card__name">{pkg.name}</h3>
                <p className="pkg-full-card__highlight">✦ {pkg.highlights}</p>
                <ul className="pkg-full-card__list">
                  {pkg.includes.map((inc,i)=><li key={i}><span>✓</span>{inc}</li>)}
                </ul>
                <Link to="/contact" className="btn-primary" style={{width:'100%',justifyContent:'center',marginTop:20}}>
                  Book This Package →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="pkg-custom-cta">
        <p className="section-eyebrow" style={{color:'var(--gold)'}}>✦ Custom Trips</p>
        <h2 className="section-title playfair" style={{color:'var(--navy)'}}>Design Your Own Sri Lanka Holiday</h2>
        <p style={{color:'var(--muted)',marginBottom:28,lineHeight:1.7}}>Tell us your dates, budget and interests — we'll craft a perfect tailor-made itinerary.</p>
        <div style={{display:'flex',gap:16,justifyContent:'center',flexWrap:'wrap'}}>
          <a href="tel:9740749793" className="btn-primary">📞 9740749793</a>
          <Link to="/contact" className="btn-secondary">Send Enquiry →</Link>
        </div>
      </section>
    </div>
  );
}

export function About() {
  return (
    <div>
      <div className="page-hero">
        <div className="page-hero-content">
          <p className="section-eyebrow">✦ Our Story</p>
          <h1 className="playfair">About Mishti Holidays</h1>
          <p>In collaboration with Onaara Tours — Your Journey, Our Passion.</p>
        </div>
      </div>

      {/* ── WHO WE ARE ── */}
      <section className="section" style={{background:'#fff'}}>
        <div className="about-grid">
          <div className="about-text">
            <p className="section-eyebrow">✦ Who We Are</p>
            <h2 className="section-title playfair">We Make Your Holiday Simply Amazing!</h2>
            <p style={{color:'var(--muted)',lineHeight:1.8,marginBottom:16}}>
              Mishti Holidays is a dedicated travel company committed to crafting
              unforgettable Sri Lanka holiday experiences. We specialise in tailor-made
              holidays for honeymoon couples, families, and corporate groups — planned
              with personal care and deep local knowledge.
            </p>
            <p style={{color:'var(--muted)',lineHeight:1.8,marginBottom:28}}>
              Every trip we plan is unique, personal, and built around you — because
              we believe travel should feel effortless and extraordinary.
            </p>
            <div className="about-values">
              {[
                ['🧑‍✈️','Friendly & Professional Team','Our guides and drivers are experienced, courteous, and passionate about Sri Lanka.'],
                ['🚗','Comfortable Transport','Modern, well-maintained vehicles for a smooth journey across the island.'],
                ['🏨','Handpicked Hotels','Only the best — vetted for comfort, service, and location.'],
                ['🛡️','Safe & Hassle Free','We handle every detail so you can focus on enjoying your holiday.'],
              ].map(([icon, title, desc]) => (
                <div key={title} className="about-value">
                  <span>{icon}</span>
                  <div><strong>{title}</strong><p>{desc}</p></div>
                </div>
              ))}
            </div>
          </div>

          <div className="about-right">
            <div className="about-stats-panel">
              {[
                ['25+','Destinations'],
                ['100%','Tailor Made'],
                ['24/7','Support'],
                ['5★','Service'],
              ].map(([n, l]) => (
                <div key={l} className="about-stat">
                  <div className="about-stat__num">{n}</div>
                  <div className="about-stat__label">{l}</div>
                </div>
              ))}
            </div>
            <img
              src={require('../assets/images/places/sigiriya.jpg')}
              alt="Sri Lanka"
              style={{width:'100%',borderRadius:'var(--radius-lg)',marginTop:20,height:220,objectFit:'cover'}}
            />
          </div>
        </div>
      </section>

      {/* ── ONAARA TOURS PARTNER SECTION ── */}
      <section className="section onaara-section">
        <div className="onaara-inner">
          <div className="onaara-badge">✦ Our Trusted Local Partner ✦</div>
          <h2 className="playfair onaara-title">Onaara Tours, Sri Lanka</h2>

          <div className="onaara-grid">
            <div className="onaara-text">
              <p>
                At <strong>Onaara Tours</strong>, your journey continues with confidence.
                As our trusted local tour partner based in <strong>Aluthgama, Sri Lanka</strong>,
                their experienced team takes care of every aspect of your trip — from
                the moment you arrive until your departure.
              </p>
              <p>
                From comfortable transportation and handpicked accommodations to
                sightseeing, local experiences, and personalized assistance, Onaara Tours
                ensures that every traveler enjoys a <strong>safe, seamless, and memorable holiday</strong>.
              </p>
              <p>
                Together, <strong>Mishti Holidays & Onaara Tours</strong> are committed to
                delivering exceptional travel experiences with professionalism, hospitality,
                and genuine Sri Lankan warmth.
              </p>

              <div className="onaara-features">
                {[
                  ['🚗','Comfortable Transportation'],
                  ['🏨','Handpicked Accommodations'],
                  ['🗺️','Sightseeing & Local Experiences'],
                  ['🤝','Personalized Assistance'],
                  ['✈️','Airport Transfers'],
                  ['🛡️','Safe & Seamless Travel'],
                ].map(([icon, text]) => (
                  <div key={text} className="onaara-feature">
                    <span>{icon}</span>
                    <span>{text}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="onaara-contact-panel">
              <div className="onaara-contact-header">
                <div className="onaara-logo">Onaara <span>Tours</span></div>
                <p>Your Local Sri Lanka Partner</p>
              </div>

              <div className="onaara-contact-details">
                <div className="onaara-contact-item">
                  <span className="onaara-contact-icon">📍</span>
                  <div>
                    <strong>Address</strong>
                    <p>241/1B, Cemetery Road,<br />Kaluwamodara, Aluthgama,<br />Sri Lanka</p>
                  </div>
                </div>
                <div className="onaara-contact-item">
                  <span className="onaara-contact-icon">📞</span>
                  <div>
                    <strong>Phone</strong>
                    <p><a href="tel:+940701133059">+94 70 113 3059</a></p>
                  </div>
                </div>
                <div className="onaara-contact-item">
                  <span className="onaara-contact-icon">💬</span>
                  <div>
                    <strong>WhatsApp</strong>
                    <p><a href="https://wa.me/940701133059">+94 70 113 3059</a></p>
                  </div>
                </div>
                <div className="onaara-contact-item">
                  <span className="onaara-contact-icon">📍</span>
                  <div>
                    <strong>Location</strong>
                    <p>Aluthgama, Western Province,<br />Sri Lanka</p>
                  </div>
                </div>
              </div>

              
               <a href="https://wa.me/940701133059"
                target="_blank"
                rel="noreferrer"
                className="btn-primary onaara-whatsapp-btn"
              >
                💬 WhatsApp Onaara Tours
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ── TOGETHER WE OFFER ── */}
      <section className="section" style={{background:'var(--blue-pale)'}}>
        <div className="section-header">
          <p className="section-eyebrow">✦ Together We Offer</p>
          <h2 className="section-title playfair">Mishti Holidays × Onaara Tours</h2>
          <p className="section-sub">A complete end-to-end Sri Lanka holiday experience — planned from India, executed with Sri Lankan expertise.</p>
        </div>
        <div className="together-grid">
          {[
            {icon:'💑', title:'Honeymoon Packages', desc:'Romantic getaways with luxury stays and private experiences.'},
            {icon:'👨‍👩‍👧‍👦', title:'Family Trips', desc:'Kid-friendly adventures with comfortable transport and hotels.'},
            {icon:'💼', title:'Corporate Tours', desc:'MICE travel, team building, and incentive trips.'},
            {icon:'🗺️', title:'Custom Itineraries', desc:'Fully tailor-made holidays built around your dates and budget.'},
            {icon:'🚗', title:'Airport Transfers', desc:'Reliable pickup and drop for all flights in and out of Sri Lanka.'},
            {icon:'🏨', title:'Hotel Bookings', desc:'Handpicked accommodations from budget to luxury.'},
          ].map(item => (
            <div key={item.title} className="together-card">
              <span className="together-icon">{item.icon}</span>
              <h4 className="playfair">{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export function Contact() {
  const [sent, setSent] = React.useState(false);
  const [sending, setSending] = React.useState(false);
  const [form, setForm] = React.useState({ name:'', email:'', phone:'', message:'', packageType:'' });
  const handle = e => setForm(p => ({...p, [e.target.name]: e.target.value}));

  const submit = async () => {
    if (!form.name || !form.email) return alert('Please fill in name and email.');
    setSending(true);
    try {
      const response = await fetch('https://mishtiholidays.com/mail.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const result = await response.json();
      if (result.success) {
        setSent(true);
      } else {
        alert('Failed to send. Please call us on 9740749793.');
      }
    } catch (err) {
      alert('Failed to send. Please call us on 9740749793.');
    }
    setSending(false);
  };

  return (
    <div>
      <div className="page-hero">
        <div className="page-hero-content">
          <p className="section-eyebrow">✦ Get In Touch</p>
          <h1 className="playfair">Plan Your Sri Lanka Holiday</h1>
          <p>Call, WhatsApp, or fill the form — our local experts respond within 24 hours.</p>
        </div>
      </div>
      <section className="section" style={{background:'var(--ivory)'}}>
        <div className="contact-layout">
          <div className="contact-info">
            <h3 className="playfair">Mishti Holidays × Onaara Tours</h3>
           <p>Based in Bangalore, India — in collaboration with Onaara Tours, Aluthgama, Sri Lanka.</p>
            <div className="contact-details">
             {[
  ['📍', <span>No:11, 1st Floor, 17th Main,<br />JP Nagar 2nd Phase,<br />Bangalore 560078</span>],
  ['📞', '9740749793'],
  ['📞', '9483549793'],
  ['💬', 'WhatsApp Available'],
  ['✉️', <a href="mailto:support@mishtiholidays.com">support@mishtiholidays.com</a>],
  ['🕐', 'Mon–Sat: 9:00am – 6:00pm'],
].map(([icon, text]) => (
                <div key={text} className="contact-detail"><span>{icon}</span><span>{text}</span></div>
              ))}
            </div>
            <div style={{marginTop:24,display:'flex',gap:12,flexWrap:'wrap'}}>
              <a href="tel:9740749793" className="btn-primary">📞 Call Now</a>
              <a href="https://wa.me/9483549793" className="btn-secondary">💬 WhatsApp</a>
            </div>
          </div>
          <div className="contact-form-card">
            {sent ? (
              <div className="contact-success">
                <span>🎉</span>
                <h3 className="playfair">Thank you, {form.name}!</h3>
                <p>We'll contact you within 24 hours to discuss your perfect Sri Lanka holiday.</p>
              </div>
            ) : (
              <>
                <div className="form-row">
                  <div className="form-group"><label>Full Name *</label><input name="name" value={form.name} onChange={handle} placeholder="Your full name" /></div>
                  <div className="form-group"><label>Email *</label><input name="email" value={form.email} onChange={handle} placeholder="your@email.com" /></div>
                </div>
                <div className="form-row">
                  <div className="form-group"><label>Phone / WhatsApp</label><input name="phone" value={form.phone} onChange={handle} placeholder="+91 or +1..." /></div>
                  <div className="form-group"><label>Package Interest</label>
                    <select name="packageType" value={form.packageType} onChange={handle}>
                      <option value="">Choose…</option>
                      <option>Honeymoon Package</option>
                      <option>Family Trip Package</option>
                      <option>Corporate Tour</option>
                      <option>Custom Itinerary</option>
                    </select>
                  </div>
                </div>
                <div className="form-group" style={{marginBottom:22}}>
                  <label>Message</label>
                  <textarea name="message" value={form.message} onChange={handle} rows={4} placeholder="Tell us your dates, group size, interests…" />
                </div>
                 <button
                  className="btn-primary"
                  style={{width:'100%', justifyContent:'center', opacity: sending ? 0.7 : 1}}
                  onClick={submit}
                  disabled={sending}
                >
                  {sending ? 'Sending…' : 'Send Enquiry →'}
                </button>
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}


export function CancellationPolicy() {
  return (
    <div>
      <div className="page-hero">
        <div className="page-hero-content">
          <p className="section-eyebrow">✦ Policies</p>
          <h1 className="playfair">Cancellation & Refund Policy</h1>
          <p>Transparent and fair policies designed with your trust in mind.</p>
        </div>
      </div>

      <section className="section" style={{background:'#fff'}}>
        <div className="policy-wrap">

          <div className="policy-intro">
            <p>
              At <strong>Mishti Holidays</strong>, we understand that travel plans may change.
              Our cancellation and refund policy is designed to be transparent and fair
              while considering commitments made to hotels, airlines, transport providers,
              and other travel partners.
            </p>
          </div>

          {/* ── CANCELLATION CHARGES ── */}
          <div className="policy-section">
            <h2 className="playfair policy-section__title">
              <span>📅</span> Cancellation Charges
            </h2>
            <div className="policy-table">
              {[
                { period: '30 days or more before departure', charge: '10%', desc: 'of total package cost deducted as service charge. Remaining amount refunded.', color: '#2E7D32' },
                { period: '15–29 days before departure',      charge: '25%', desc: 'of total package cost will be charged.',                                      color: '#F57F17' },
                { period: '7–14 days before departure',       charge: '50%', desc: 'of total package cost will be charged.',                                      color: '#E65100' },
                { period: 'Less than 7 days or No Show',      charge: '100%', desc: 'cancellation charges apply. No refund will be provided.',                   color: '#C62828' },
              ].map(row => (
                <div key={row.period} className="policy-table__row">
                  <div className="policy-table__period">
                    <span className="policy-table__dot" style={{background: row.color}} />
                    {row.period}
                  </div>
                  <div className="policy-table__charge" style={{color: row.color}}>
                    {row.charge}
                  </div>
                  <div className="policy-table__desc">{row.desc}</div>
                </div>
              ))}
            </div>
          </div>

          {/* ── FLIGHT TICKETS ── */}
          <div className="policy-section">
            <h2 className="playfair policy-section__title">
              <span>✈️</span> Flight Tickets
            </h2>
            <ul className="policy-list">
              <li>Airline tickets are subject to the cancellation and refund policies of the respective airline.</li>
              <li>Promotional or special fare tickets may be non-refundable.</li>
            </ul>
          </div>

          {/* ── HOTEL BOOKINGS ── */}
          <div className="policy-section">
            <h2 className="playfair policy-section__title">
              <span>🏨</span> Hotel Bookings
            </h2>
            <ul className="policy-list">
              <li>Hotels may have their own cancellation policies.</li>
              <li>Any non-refundable hotel charges will be deducted from the refundable amount.</li>
            </ul>
          </div>

          {/* ── REFUND PROCESS ── */}
          <div className="policy-section">
            <h2 className="playfair policy-section__title">
              <span>💰</span> Refund Process
            </h2>
            <ul className="policy-list">
              <li>All cancellation requests must be submitted in writing via <strong>email or WhatsApp</strong>.</li>
              <li>Eligible refunds will be processed within <strong>10–15 working days</strong> after confirmation of cancellation.</li>
              <li>Bank charges, payment gateway charges, visa fees, travel insurance, and government taxes (if applicable) are <strong>non-refundable</strong>.</li>
            </ul>
          </div>

          {/* ── CHANGES & AMENDMENTS ── */}
          <div className="policy-section">
            <h2 className="playfair policy-section__title">
              <span>✏️</span> Changes & Amendments
            </h2>
            <ul className="policy-list">
              <li>Any changes to confirmed bookings are subject to availability and may incur additional charges from hotels, airlines, transport providers, or other service partners.</li>
            </ul>
          </div>

          {/* ── FORCE MAJEURE ── */}
          <div className="policy-section policy-section--warning">
            <h2 className="playfair policy-section__title">
              <span>⚠️</span> Force Majeure
            </h2>
            <p className="policy-warning-text">
              Mishti Holidays shall not be held responsible for cancellations, delays,
              or itinerary changes caused by natural disasters, adverse weather conditions,
              political unrest, pandemics, government restrictions, airline disruptions,
              or any other circumstances beyond our control. Any refunds in such cases
              will depend solely on the policies of the respective service providers.
            </p>
          </div>

          {/* ── AGREEMENT ── */}
          <div className="policy-agreement">
            <span>✅</span>
            <p>
              By confirming your booking with <strong>Mishti Holidays</strong>, you acknowledge
              that you have read, understood, and agreed to the above Cancellation & Refund Policy.
            </p>
          </div>

          {/* ── CONTACT CTA ── */}
          <div className="policy-contact">
            <h3 className="playfair">Have Questions?</h3>
            <p>Contact us before booking — we are happy to clarify any part of our policy.</p>
            <div className="policy-contact__btns">
              <a href="tel:9740749793" className="btn-primary">📞 9740749793</a>
              <a href="https://wa.me/9740749793" target="_blank" rel="noreferrer" className="btn-secondary">💬 WhatsApp Us</a>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export function TermsConditions() {
  const terms = [
    {
      number: '01',
      title: 'Booking Confirmation',
      points: [
        'A booking is confirmed only after the required advance payment is received and confirmed by Mishti Holidays.',
        'All bookings are subject to availability of hotels, flights, transport, and other travel services.',
      ],
    },
    {
      number: '02',
      title: 'Payment Policy',
      points: [
        'An advance payment is required to secure your booking.',
        'The remaining balance must be paid before the tour commencement as communicated during booking.',
        'Failure to complete payment within the specified time may result in cancellation of the booking.',
      ],
    },
    {
      number: '03',
      title: 'Pricing',
      points: [
        'Package prices are based on current hotel, airline, transport, and government charges.',
        'Prices are subject to change before booking confirmation due to currency fluctuations, supplier price revisions, or changes in government taxes.',
      ],
    },
    {
      number: '04',
      title: 'Travel Documents',
      points: [
        'Guests are responsible for ensuring they possess a valid passport, visa, travel insurance, and any other documents required for their destination.',
        'Mishti Holidays is not responsible for losses arising from incomplete or invalid travel documents.',
      ],
    },
    {
      number: '05',
      title: 'Itinerary Changes',
      points: [
        'Tour itineraries may be modified due to weather conditions, road closures, airline schedule changes, government regulations, or unforeseen circumstances.',
        'We will make every effort to provide suitable alternatives whenever possible.',
      ],
    },
    {
      number: '06',
      title: 'Hotel Check-in & Check-out',
      points: [
        'Standard hotel check-in and check-out timings are governed by the respective hotel.',
        'Early check-in and late check-out are subject to availability and may incur additional charges.',
      ],
    },
    {
      number: '07',
      title: 'Cancellation & Refunds',
      points: [
        'Cancellation requests must be submitted in writing.',
        'Refunds will be processed according to Mishti Holidays\' Cancellation & Refund Policy.',
        'Airlines, hotels, and other suppliers may apply separate cancellation charges.',
      ],
    },
    {
      number: '08',
      title: 'Responsibility',
      points: [
        'Mishti Holidays acts only as an intermediary between guests and service providers such as airlines, hotels, transport operators, and sightseeing providers.',
        'We are not liable for delays, cancellations, accidents, baggage loss, or service deficiencies caused by third-party suppliers.',
      ],
    },
    {
      number: '09',
      title: 'Force Majeure',
      points: [
        'Mishti Holidays shall not be held responsible for delays, cancellations, itinerary changes, or losses caused by natural disasters, adverse weather, political unrest, strikes, pandemics, government regulations, airline disruptions, or any event beyond our reasonable control.',
      ],
    },
    {
      number: '10',
      title: 'Guest Conduct',
      points: [
        'Guests are expected to behave respectfully throughout the tour. Mishti Holidays reserves the right to refuse or terminate services without refund if a guest\'s behavior endangers others, damages property, or violates local laws.',
      ],
    },
    {
      number: '11',
      title: 'Travel Insurance',
      points: [
        'We strongly recommend that every traveler purchase comprehensive travel insurance covering medical emergencies, trip cancellations, baggage loss, and other unforeseen events.',
      ],
    },
    {
      number: '12',
      title: 'Privacy',
      points: [
        'All personal information shared with Mishti Holidays will be used solely for processing bookings and delivering travel services.',
        'We respect your privacy and do not disclose personal information except where necessary to complete your travel arrangements.',
      ],
    },
    {
      number: '13',
      title: 'Acceptance',
      points: [
        'By confirming your booking with Mishti Holidays, you acknowledge that you have read, understood, and agreed to these Terms & Conditions.',
      ],
    },
  ];

  return (
    <div>
      <div className="page-hero">
        <div className="page-hero-content">
          <p className="section-eyebrow">✦ Legal</p>
          <h1 className="playfair">Terms & Conditions</h1>
          <p>Your Journey, Our Passion — Please read these terms carefully before booking.</p>
        </div>
      </div>

      <section className="section" style={{background:'#fff'}}>
        <div className="terms-wrap">

          {/* INTRO */}
          <div className="terms-intro">
            <div className="terms-intro__logo">Mishti <span>Holidays</span></div>
            <p>
              Welcome to <strong>Mishti Holidays</strong>. By booking any tour, holiday package,
              transportation, hotel, or travel-related service with us, you agree to the
              following Terms & Conditions.
            </p>
          </div>

          {/* TERMS LIST */}
          <div className="terms-list">
            {terms.map(term => (
              <div key={term.number} className="terms-item">
                <div className="terms-item__header">
                  <div className="terms-item__number">{term.number}</div>
                  <h3 className="playfair terms-item__title">{term.title}</h3>
                </div>
                <div className="terms-item__body">
                  <ul>
                    {term.points.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          {/* FORCE MAJEURE HIGHLIGHT */}
          <div className="terms-warning">
            <span>⚠️</span>
            <div>
              <strong>Force Majeure</strong>
              <p>
                Mishti Holidays shall not be held responsible for delays, cancellations,
                itinerary changes, or losses caused by events beyond our reasonable control
                including natural disasters, pandemics, or government regulations.
              </p>
            </div>
          </div>

          {/* ACCEPTANCE */}
          <div className="terms-acceptance">
            <span>✅</span>
            <p>
              By confirming your booking with <strong>Mishti Holidays</strong>, you acknowledge
              that you have read, understood, and agreed to these Terms & Conditions.
            </p>
          </div>

          {/* BRAND FOOTER */}
          <div className="terms-brand-footer">
            <div className="terms-brand-footer__logo">Mishti <span>Holidays</span></div>
            <p>Your Journey, Our Passion</p>
            <div className="terms-brand-footer__links">
              <Link to="/cancellation-policy">Cancellation Policy</Link>
              <span>·</span>
              <Link to="/contact">Contact Us</Link>
              <span>·</span>
              <Link to="/about">About Us</Link>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}


export function InternationalPackages() {
  const [active, setActive] = React.useState('thailand');

  const destinations = [
    {
      id: 'thailand',
      flag: '🇹🇭',
      name: 'Thailand',
      tagline: 'Land of Smiles',
      image: thailandImg,
      color: '#1565C0',
      gradient: 'linear-gradient(135deg, #0D47A1 0%, #1565C0 100%)',
      desc: 'From golden temples and vibrant night markets to turquoise beaches and lush jungles — Thailand is a feast for all the senses. One of Asia\'s most rewarding destinations, just a short flight from India.',
      highlights: [
        { icon:'🏯', label:'Grand Palace, Bangkok' },
        { icon:'🏖️', label:'Phi Phi Islands, Phuket' },
        { icon:'🐘', label:'Elephant Sanctuary, Chiang Mai' },
        { icon:'🛥️', label:'James Bond Island' },
        { icon:'🍜', label:'Thai Street Food Culture' },
        { icon:'🌴', label:'Maya Bay & Krabi' },
      ],
      facts: [
        
        { icon:'🌡️', label:'Best Season', value:'Nov – Apr' },
        { icon:'💰', label:'Currency', value:'Thai Baht' },
        { icon:'🗣️', label:'Language', value:'Thai / English' },
      ],
    },
    {
      id: 'vietnam',
      flag: '🇻🇳',
      name: 'Vietnam',
      tagline: 'The Hidden Gem of Southeast Asia',
      image: vietnamImg,
      color: '#B71C1C',
      gradient: 'linear-gradient(135deg, #7F0000 0%, #B71C1C 100%)',
      desc: 'Vietnam captivates with its dramatic karst landscapes, ancient lantern-lit towns, vibrant cities, and world-renowned cuisine. From the emerald waters of Ha Long Bay to the golden streets of Hoi An.',
      highlights: [
        { icon:'🚢', label:'Ha Long Bay Cruise' },
        { icon:'🏮', label:'Hoi An Ancient Town' },
        { icon:'🏛️', label:'Hue Imperial Citadel' },
        { icon:'🌾', label:'Sapa Rice Terraces' },
        { icon:'🍜', label:'Vietnamese Pho & Cuisine' },
        { icon:'🏙️', label:'Ho Chi Minh City' },
      ],
      facts: [
        { icon:'✈️', label:'Flight from Bangalore', value:'~4.5 hrs' },
        { icon:'🌡️', label:'Best Season', value:'Feb – Apr' },
        { icon:'💰', label:'Currency', value:'Vietnamese Dong' },
        { icon:'🗣️', label:'Language', value:'Vietnamese / English' },
      ],
    },
  ];

  const current = destinations.find(d => d.id === active);

  return (
    <div className="intl-v2-page">

      {/* ── HERO ── */}
      <div className="intl-v2-hero">
        <div className="intl-v2-hero__bg" style={{backgroundImage:`url(${current.image})`}} />
        <div className="intl-v2-hero__overlay" style={{background: current.gradient.replace('linear-gradient', 'linear-gradient').replace(')', ', 0.75)')}} />
        <div className="intl-v2-hero__overlay" style={{background:'rgba(0,0,0,0.35)'}} />
        <div className="intl-v2-hero__content">
          <p className="section-eyebrow">✦ International Packages</p>
          <div className="intl-v2-hero__flag">{current.flag}</div>
          <h1 className="playfair intl-v2-hero__title">{current.name}</h1>
          <p className="intl-v2-hero__tagline">✦ {current.tagline} ✦</p>
          <p className="intl-v2-hero__sub">{current.desc}</p>

          {/* TABS */}
          <div className="intl-v2-tabs">
            {destinations.map(d => (
              <button
                key={d.id}
                className={`intl-v2-tab ${active === d.id ? 'intl-v2-tab--active' : ''}`}
                onClick={() => setActive(d.id)}
              >
                {d.flag} {d.name}
              </button>
            ))}
          </div>
        </div>

        {/* FACTS BAR */}
        {/* <div className="intl-v2-facts">
          {current.facts.map(f => (
            <div key={f.label} className="intl-v2-fact">
              <span className="intl-v2-fact__icon">{f.icon}</span>
              <div>
                <span className="intl-v2-fact__label">{f.label}</span>
                <strong className="intl-v2-fact__value">{f.value}</strong>
              </div>
            </div>
          ))}
        </div> */}
      </div>

      {/* ── HIGHLIGHTS ── */}
      <section className="section intl-v2-highlights" style={{background:'#fff'}}>
        <div className="section-header">
          <p className="section-eyebrow">✦ {current.name} Highlights</p>
          <h2 className="section-title playfair">Must-See Experiences</h2>
          <p className="section-sub">Handpicked attractions and experiences we include in your {current.name} holiday.</p>
        </div>
        <div className="intl-v2-highlights-grid">
          {current.highlights.map((h, i) => (
            <div key={h.label} className="intl-v2-highlight-card" style={{'--card-color': current.color}}>
              <div className="intl-v2-highlight-card__num">{String(i+1).padStart(2,'0')}</div>
              <div className="intl-v2-highlight-card__icon">{h.icon}</div>
              <h4 className="playfair">{h.label}</h4>
            </div>
          ))}
        </div>
      </section>

      {/* ── WHAT WE OFFER ── */}
      <section className="section" style={{background:'var(--sand)'}}>
        <div className="section-header">
          <p className="section-eyebrow">✦ What We Handle</p>
          <h2 className="section-title playfair">Complete Holiday Planning</h2>
          <p className="section-sub">From the moment you enquire to the moment you return — we handle everything.</p>
        </div>
        <div className="intl-v2-offer-grid">
          {[
            { icon:'✈️', title:'Flight Assistance', desc:'Help with finding and booking the best flight options.' },
            { icon:'🏨', title:'Hotel Bookings', desc:'Handpicked 3★ to 5★ hotels at every destination.' },
            { icon:'🚗', title:'Local Transport', desc:'AC vehicles with professional drivers throughout.' },
            { icon:'🗺️', title:'Guided Tours', desc:'Expert local guides at all major attractions.' },
            { icon:'📋', title:'Visa Assistance', desc:'Guidance on visa requirements and application.' },
            { icon:'🛡️', title:'24/7 Support', desc:'Always reachable during your entire journey.' },
          ].map(o => (
            <div key={o.title} className="intl-v2-offer-card" style={{'--offer-color': current.color}}>
              <span className="intl-v2-offer-icon">{o.icon}</span>
              <h4 className="playfair">{o.title}</h4>
              <p>{o.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── ALSO AVAILABLE ── */}
      <section className="section" style={{background:'#fff'}}>
        <div className="section-header">
          <p className="section-eyebrow">✦ More Coming Soon</p>
          <h2 className="section-title playfair">We Are Expanding</h2>
          <p className="section-sub">More international destinations are coming soon — stay tuned!</p>
        </div>
        <div className="intl-v2-coming-grid">
          {[
            { flag:'🇸🇬', name:'Singapore', desc:'City of Gardens & Marina Bay Sands' },
            { flag:'🇲🇾', name:'Malaysia', desc:'Petronas Towers & Langkawi Beaches' },
            { flag:'🇮🇩', name:'Bali', desc:'Island of Gods & Rice Terraces' },
            { flag:'🇦🇪', name:'Dubai', desc:'Desert Safari & Burj Khalifa' },
          ].map(d => (
            <div key={d.name} className="intl-v2-coming-card">
              <span className="intl-v2-coming-flag">{d.flag}</span>
              <h4 className="playfair">{d.name}</h4>
              <p>{d.desc}</p>
              <span className="intl-v2-coming-badge">Coming Soon</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="intl-v2-cta" style={{background: current.gradient}}>
        <div className="intl-v2-cta__inner">
          <span className="intl-v2-cta__flag">{current.flag}</span>
          <p className="section-eyebrow" style={{color:'var(--gold-light)'}}>✦ Plan Your Trip</p>
          <h2 className="playfair intl-v2-cta__title">
            Ready to Explore {current.name}?
          </h2>
          <p className="intl-v2-cta__sub">
            Call or WhatsApp us with your destination, travel dates, and group size —
            we will plan the perfect international holiday for you.
          </p>
          <div className="intl-v2-cta__btns">
            <a href="tel:9740749793" className="btn-primary">📞 9740749793</a>
            <a href="https://wa.me/940701133059" target="_blank" rel="noreferrer" className="btn-outline-white">💬 WhatsApp</a>
            {/* <a href="/contact" className="btn-outline-white">Send Enquiry →</a> */}
          </div>
        </div>
      </section>

    </div>
  );
}